import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { initAnalytics } from './analytics.js'
import './index.css'
import './lib/theme.js'
import App from './App.jsx'

initAnalytics()

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    beforeSend(event) {
      // Scrub PII from error events
      if (event.request?.data) {
        const data = typeof event.request.data === 'string'
          ? event.request.data
          : JSON.stringify(event.request.data)
        if (/access_token|plaid_access|account_number|ssn|routing/i.test(data)) {
          event.request.data = '[REDACTED]'
        }
      }
      return event
    },
    beforeBreadcrumb(breadcrumb) {
      // Drop breadcrumbs that might contain financial data
      if (breadcrumb.category === 'xhr' || breadcrumb.category === 'fetch') {
        if (/plaid-exchange|service_role/i.test(breadcrumb.data?.url || '')) {
          breadcrumb.data = { url: breadcrumb.data?.url, status_code: breadcrumb.data?.status_code }
        }
      }
      return breadcrumb
    },
  })
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<div style={{padding:40,color:'#ccc',fontFamily:'monospace'}}>Something went wrong. Reloading...</div>}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
